export default "__VITE_PUBLIC_ASSET__eb7e9468__"